module.exports = __webpack_public_path__ + "static/media/vip_mobile.8242bad9.png";